(function () {
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  class GlazyMixMatch extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.productHandle;
      this.productVariantId = this.dataset.defaultVariantId;
      this.productPriceCents = parseInt(this.dataset.productPriceCents, 10) || 0;
      this.mmPct = parseInt(window.GLAZY_MM_DISCOUNT_PCT, 10) || 10;
      this.tiers = window.GLAZY_QTY_TIERS || [];

      this.selectedOffer = 'qty-2';
      this.activePartnerBtn = this.querySelector('.glazy-mm__partner-option.is-active');

      this.validatePartner();
      this.renderQtyTiers();
      if (this.activePartnerBtn) this.refreshPairUI();

      this.bindRadios();
      this.bindPartnerSwitch();
      this.bindPairCardClick();
      this.bindAtc();

      this.syncSelectedClass();
    }

    /**
     * Catch-all: any tap anywhere inside the Mix & Match pair card selects
     * the pair offer. This is the fallback for cases where the implicit
     * label-toggle gets eaten (e.g., the partner-option preventDefault), or
     * where the user taps a non-form region.
     */
    bindPairCardClick() {
      var self = this;
      var pairCard = this.querySelector('.glazy-mm__card--pair');
      if (!pairCard) return;
      pairCard.addEventListener('click', function () {
        var pairRadio = self.querySelector('input[type="radio"][value="pair"]');
        if (pairRadio && !pairRadio.checked) {
          pairRadio.checked = true;
          self.selectedOffer = 'pair';
          self.syncSelectedClass();
        }
      });
    }

    /**
     * Toggle `.is-selected` on cards + apply inline styles as a CDN-cache-proof
     * fallback. Inline styles ship in the HTML attribute, so they always apply
     * regardless of stale CSS being served from cache.
     */
    syncSelectedClass() {
      var cards = this.querySelectorAll('.glazy-mm__card');
      cards.forEach(function (card) {
        var input = card.querySelector('input[type="radio"]');
        var radio = card.querySelector('.glazy-mm__radio');
        if (input && input.checked) {
          card.classList.add('is-selected');
          card.style.background = '#ffc355';
          card.style.borderColor = '#000';
          card.style.borderWidth = '2px';
          if (radio) radio.style.background = 'radial-gradient(circle, #000 45%, transparent 50%)';
        } else {
          card.classList.remove('is-selected');
          card.style.background = '';
          card.style.borderColor = '';
          card.style.borderWidth = '';
          if (radio) radio.style.background = '';
        }
      });
    }

    /**
     * Defensive check: hide MM card if the active partner button matches the
     * host product (the Rapi duplicate-partner bug guardrail).
     */
    validatePartner() {
      if (!this.activePartnerBtn) return false;
      if (this.activePartnerBtn.dataset.partnerHandle === this.handle) {
        console.warn('[glazy-mm] partner handle equals host; removing MM card', this.handle);
        var card = this.querySelector('[data-offer="pair"]');
        if (card) card.remove();
        this.activePartnerBtn = null;
        return false;
      }
      return true;
    }

    renderQtyTiers() {
      var self = this;
      this.tiers.forEach(function (tier) {
        if (tier.qty === 1) return;
        var discountedPerUnit = Math.round(self.productPriceCents * (100 - tier.discount_pct) / 100);
        var discountedTotal = discountedPerUnit * tier.qty;
        var originalTotal = self.productPriceCents * tier.qty;
        var totalSavings = originalTotal - discountedTotal;
        // Per-unit (kept for backward compat — not currently rendered)
        self.qSet('qty-' + tier.qty + '-discounted-per-unit', formatMoney(discountedPerUnit));
        self.qSet('qty-' + tier.qty + '-original-per-unit', formatMoney(self.productPriceCents));
        // Total + savings (the new prominent display)
        self.qSet('qty-' + tier.qty + '-discounted-total', formatMoney(discountedTotal));
        self.qSet('qty-' + tier.qty + '-original-total', formatMoney(originalTotal));
        self.qSet('qty-' + tier.qty + '-savings', formatMoney(totalSavings) + ' SAVED');
      });
    }

    refreshPairUI() {
      if (!this.activePartnerBtn) return;
      var partnerHandle = this.activePartnerBtn.dataset.partnerHandle;
      var partnerPriceCents = parseInt(this.activePartnerBtn.dataset.partnerPriceCents, 10) || 0;
      var subtotal = this.productPriceCents + partnerPriceCents;
      var discounted = Math.round(subtotal * (100 - this.mmPct) / 100);
      var savings = subtotal - discounted;

      this.qSet('pair-discounted', formatMoney(discounted));
      this.qSet('pair-original', formatMoney(subtotal));
      this.qSet('pair-savings', formatMoney(savings) + ' SAVED');
      var copyKey = this.handle + '|' + partnerHandle;
      this.qSet('pair-copy', (window.GLAZY_PAIR_COPY && window.GLAZY_PAIR_COPY[copyKey]) || '');
    }

    bindRadios() {
      var self = this;
      this.querySelectorAll('input[type="radio"]').forEach(function (r) {
        r.addEventListener('change', function () {
          self.selectedOffer = r.value;
          self.syncSelectedClass();
        });
      });
    }

    bindPartnerSwitch() {
      var self = this;
      this.querySelectorAll('.glazy-mm__partner-option').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.querySelectorAll('.glazy-mm__partner-option').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          self.activePartnerBtn = btn;
          self.refreshPairUI();

          // Tapping a partner = user wants the Mix & Match offer selected.
          // Manually fire the radio + sync visual state (the preventDefault above blocks the
          // implicit radio toggle from <label for=...>).
          var pairRadio = self.querySelector('input[type="radio"][value="pair"]');
          if (pairRadio && !pairRadio.checked) {
            pairRadio.checked = true;
            self.selectedOffer = 'pair';
            self.syncSelectedClass();
          }
        });
      });
    }

    bindAtc() {
      var self = this;
      var btn = this.querySelector('[data-role=atc]');
      if (!btn) return;
      btn.addEventListener('click', async function () {
        btn.disabled = true;
        try {
          var items = self.itemsForOffer(self.selectedOffer);
          await self.addToCart(items);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        } catch (err) {
          console.error('[glazy-mm] add-to-cart failed', err);
          alert('Sorry — couldn’t add to cart. Please try again.');
        } finally {
          btn.disabled = false;
        }
      });
    }

    itemsForOffer(offer) {
      if (offer === 'qty-1') return [{ id: this.productVariantId, quantity: 1 }];
      if (offer === 'qty-2') return [{ id: this.productVariantId, quantity: 2 }];
      if (offer === 'qty-4') return [{ id: this.productVariantId, quantity: 4 }];
      if (offer === 'pair') {
        if (!this.activePartnerBtn) {
          return [{ id: this.productVariantId, quantity: 1 }];
        }
        var partnerVariantId = this.activePartnerBtn.dataset.partnerVariantId;
        return [
          { id: this.productVariantId, quantity: 1, properties: { _glazy_mm_pair: 'true' } },
          { id: partnerVariantId, quantity: 1, properties: { _glazy_mm_pair: 'true' } }
        ];
      }
      return [{ id: this.productVariantId, quantity: 1 }];
    }

    async addToCart(items) {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) {
        var err;
        try { err = await res.json(); } catch (_) { err = { description: 'Add to cart failed' }; }
        throw new Error(err.description || 'Add to cart failed');
      }
      return res.json();
    }

    qSet(role, value) {
      var el = this.querySelector('[data-role="' + role + '"]');
      if (el) el.textContent = value;
    }
  }

  if (!customElements.get('glazy-mix-match')) {
    customElements.define('glazy-mix-match', GlazyMixMatch);
  }
})();
